import { Job } from '@applicator/shared'

import { TableColumn } from '../../Table'

// Helper function to map column name to key
export function mapColumnNameToKey(columnName: string): string | null {
  const columnNameMap: Record<string, string> = {
    'position': 'Job Position',
    'company': 'Company',
    'salary': 'Salary',
    'location': 'Location',
    'status': 'Status',
    'dateSaved': 'Date Saved',
    'dateApplied': 'Date Applied',
    'followUp': 'Follow up',
    'deadline': 'Deadline',
    'excitement': 'Excitement',
  }
  return columnNameMap[columnName] || null
}

// Helper function to find sort column key
export function findSortColumnKey(
  sortColumn: string | null,
  tableColumns: TableColumn<Job>[]
): string | null {
  if (!sortColumn) return null
  
  const column = tableColumns.find(col => {
    const mappedName = mapColumnNameToKey(col.key)
    return mappedName === sortColumn
  })
  
  return column?.key || null
}

// Helper function to get empty message
export function getEmptyMessage(
  searchQuery: string,
  sortedFilteredJobsLength: number,
  jobsLength: number
): string {
  if (searchQuery.trim() && sortedFilteredJobsLength === 0 && jobsLength > 0) {
    return `No jobs match your search query "${searchQuery}"`
  }
  return 'No jobs yet. Run a search query or add a job.'
}
